import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { buildWhatsAppLink, generalEnquireMessage } from "@/lib/whatsapp";

export const WhatsAppFloat = () => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger asChild>
        <a
          href={buildWhatsAppLink(generalEnquireMessage())}
          target="_blank"
          rel="noopener noreferrer"
          className="fixed bottom-6 left-6 z-40 h-14 w-14 rounded-full bg-whatsapp text-whatsapp-foreground shadow-elegant flex items-center justify-center hover:scale-105 transition-transform duration-300"
          data-testid="whatsapp-float-btn"
          aria-label="Chat on WhatsApp"
        >
          <span className="absolute inline-flex h-full w-full rounded-full bg-whatsapp opacity-40 animate-glow-pulse" aria-hidden="true" />
          <i className="fa-brands fa-whatsapp text-2xl relative z-10" />
        </a>
      </TooltipTrigger>
      <TooltipContent side="right">Chat with us on WhatsApp</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
